<template>
  <div>
    <el-page-header @back="goBack" content="充值分组配置"></el-page-header>
    <el-card class="form-container" shadow="never">
      <el-form :inline="true" :model="queryData" size="small" label-width="140px">
        <el-button class="sub-sub" type="primary" @click="showDetails('创建')">创建分组</el-button>
      </el-form>
    </el-card>
    <h1>
      <el-table border :data="dataList">
        <el-table-column label="ID" prop="id"  align="center"></el-table-column>
        <el-table-column label="名称" prop="name" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column label="状态" align="center" width="100px">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.state"
                :active-value="true"
                active-text="开"
                inactive-text="关"
                @change="switchState(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="150px">
          <template slot-scope="scope">
            <el-button plain size="mini" type="primary" @click="showDetails('编辑',scope.row)">编辑</el-button>
<!--            <el-button plain size="mini" type="danger" @click="removeItem(scope.row.id)">删除</el-button>-->
          </template>
        </el-table-column>
      </el-table>
      <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="800px"
                 :close-on-click-modal="false">
        <el-form :model="itemForm" label-width="150px">

          <el-form-item label="名称 :">
            <el-input style="width: 300px" type="text" v-model="itemForm.name"  ></el-input>
          </el-form-item>
          <el-form-item label="状态 :" :label-width="labelWidth">
            <el-switch
                v-model="itemForm.state"
                :active-value="true"
                active-text="开"
                inactive-text="关">
            </el-switch>
          </el-form-item>
          <div style="text-align: center;">
            <el-button type="primary" @click="confirm">确 定</el-button>
            <el-button type="info" @click="cancel">取 消</el-button>
          </div>
        </el-form>
      </el-dialog>
    </h1>
  </div>

</template>

<script>
import {
  dailyShopItemType,
  searchDailyShopItem,
  deleteDailyShopItem,
  saveDailyShopItem,
  findGoodById,
  goodsSelections, updateRechargeState, updateRechargeGroupState, searchRechargeGroup, saveRechargeGroup,
} from "@/http/iosApi";
import settingMix from '@/utils/mix/common-setting'
export default {
  name: "RechargeGroupManage",
  mixins: [settingMix],
  data(){
    return{
      VUE_APP_IOS_URL: '',
      VUE_APP_CDN_URL: '',
      dialogVisible: false,
      dialogTitle: '',
      headers: {},
      labelWidth: '200px',
      uploadURL: process.env.VUE_APP_IOS_URL + "block/upload",
      queryData: {
        dailyType : 0,
        prop: "id",
        order: "desc"
      },
      itemForm:{
        "id": 0,
        "name": '',
        "state": false,
      },
      dataList:[],
      goods:[],
    }
  },
  methods:{
    goBack() {
      this.$router.push({ path: '/rechargeManage'});
    },
    queryList() {
      searchRechargeGroup().then(resp => {
        if (resp.data.status === 0) {
          this.dataList = resp.data.info;
        }
      })
    },

    switchState(row) {
      console.log("switchState->row:", row);
      let id = row.id;
      let state  = row.state?1:0;
      console.log(`switchState->row:${row.state} state:${state}`)
      updateRechargeGroupState(id,state).then(resp=>{
        if (resp.data.status===1){
          this.queryList();
        }
      })
    },
    showDetails(title, row) {
      console.log(this.queryData)
      this.itemForm={
        "id": 0,
        "name": '',
        "state": false,
      };
      this.dialogTitle = title;
      this.dialogVisible = true;
      if (row) {
        this.itemForm={
          "id": row.id,
          "name": row.name,
          "state": row.state,
        }
      }
    },
    cancel() {
      this.dialogVisible = false;
    },
    confirm() {
      let _message = '';
      if (this.itemForm.name === '') {
        _message = '请填写名称'
      }
      if (_message) {
        this.$message({
          message: _message,
          type: 'error'
        });
        return;
      }
      // console.log(this.itemForm)
      saveRechargeGroup(this.itemForm).then(resp => {
        if (resp.data.status === 0) {
          this.queryList();
          this.dialogVisible = false;
        }
      })
    },
  },
  created() {
    this.headers = {Authorization: this.$store.state.user.token}
    this.queryList();
  },
  mounted() {
    this.VUE_APP_IOS_URL = process.env.VUE_APP_IOS_URL;
    this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
  }
}
</script>

<style scoped>

</style>
